export async function fetchJsonOrThrow(url) {
  const response = await fetch(url, { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Failed to load ${url}: ${response.status}`);
  }

  const text = await response.text();
  if (!text.trim()) {
    throw new Error(`Empty JSON response from ${url}`);
  }

  try {
    return JSON.parse(text);
  } catch {
    throw new Error(`Invalid JSON response from ${url}`);
  }
}
